import { useEffect } from "react";
import { useLocationStore } from "@/stores/useLocationStore";
import type { Tables } from "@stockuj/types";

/**
 * Initializes the location store once locations are loaded.
 * - First load (null): sets to primary location
 * - "all": always valid
 * - Stale ID (deleted location): falls back to primary
 */
export function useInitLocation(locations: Tables<"locations">[] | undefined) {
  const currentLocationId = useLocationStore((s) => s.currentLocationId);
  const setLocation = useLocationStore((s) => s.setLocation);

  useEffect(() => {
    if (!locations?.length) return;

    const first = locations[0];
    if (!first) return;
    const primary = locations.find((l) => l.is_primary) ?? first;

    // First load — no stored value
    if (currentLocationId === null) {
      setLocation(primary.id);
      return;
    }

    // "all" is always valid
    if (currentLocationId === "all") return;

    // Stored location was deleted — fall back to primary
    if (!locations.some((l) => l.id === currentLocationId)) {
      setLocation(primary.id);
    }
  }, [locations, currentLocationId, setLocation]);
}
